module.exports = __webpack_public_path__ + "static/media/download-arrow-down-svgrepo-com.e5a17211.svg";